module.exports = __webpack_public_path__ + "static/media/photo1.41629723.jpg";